import { defineStore } from "pinia";
import { ref } from "vue";

interface SortState {
  field: string;
  order: "asc" | "desc";
}

export const useTablePreferencesStore = defineStore("tablePreferences", () => {
  const sortStates = ref<Record<string, SortState>>({});

  function restoreFromStorage() {
    try {
      const saved = localStorage.getItem("tablePreferences");
      if (saved) {
        sortStates.value = JSON.parse(saved);
      }
    } catch {
      sortStates.value = {};
    }
  }

  function persist() {
    localStorage.setItem("tablePreferences", JSON.stringify(sortStates.value));
  }

  function getSortState(tableKey: string): SortState | null {
    return sortStates.value[tableKey] ?? null;
  }

  function setSortState(tableKey: string, field: string, order: "asc" | "desc") {
    sortStates.value[tableKey] = { field, order };
    persist();
  }

  function resetSortState(tableKey: string) {
    delete sortStates.value[tableKey];
    persist();
  }

  function clearAll() {
    sortStates.value = {};
    localStorage.removeItem("tablePreferences");
  }

  return {
    sortStates,
    restoreFromStorage,
    getSortState,
    setSortState,
    resetSortState,
    clearAll,
  };
});
